/*
 * COPYRIGHT (c) 2022
 * HONEYWELL INC.,
 * ALL RIGHTS RESERVED
 *
 * This software is a copyrighted work and/or information protected as a trade secret.
 * Legal rights of Honeywell Inc. in this software is distinct from ownership of any medium
 * in which the software is embodied. Copyright or trade secret notices included must be
 * reproduced in any copies authorized by Honeywell Inc.
 *
 */

import React, { useContext, useState } from 'react';
import { DataContextProvider } from '@forge/data-connector';
import IEnergyManagementProps from '../IEnergyManagementProps';
import { useTranslation } from '@scuf/localization';
import descriptors from '../../../locales/en-US/descriptors';
import EmaasEnergyUsageHOCSite from './EmaasEnergyUsageHOC/EmaasEnergyUsageHOCSite';
import '../../../scss/KPICardTheme.scss';
import '../EmaasEnergyUsage/EmaasEnergyUsageHOC/EmaasEnergyUsageHOC.scss';
import EmaasEnergyUsageHOCSiteSeparateAPI from './EmaasEnergyUsageHOC/EmaasEnergyUsageHOCSiteSeparateAPI';
import { EmaasSubscriptionType } from '../../shared/Enums';
import { ApiContext } from '../../../context/ApiContext';
import { EnergyUsageDataSourceType } from '../../shared/Enums';
import { shouldComponentNotUpdate } from '../../shared/Utils/Utils';

const EmaasEnergyUsageWidgetSite = React.memo(
  (props: IEnergyManagementProps) => {
    const {
      connectorConfig,
      bearerToken,
      requestContext,
      emaasContext,
      dataSourceType,
      setDataSourceType
    } = props;
    const d = descriptors.energyManagement;
    const [t] = useTranslation();

    const apiContext = useContext(ApiContext);

    const isSitePremium =
      requestContext.context.subscriptionType ===
        EmaasSubscriptionType.PREMIUM_SUBSCRIPTION &&
      apiContext.toggleSeparateApi &&
      dataSourceType !== EnergyUsageDataSourceType.UTILITY_METER;
    return (
      <DataContextProvider config={connectorConfig}>
        {isSitePremium ? (
          <EmaasEnergyUsageHOCSiteSeparateAPI
            requestContext={requestContext}
            bearerToken={bearerToken}
            emaasContext={emaasContext}
            dataSourceType={dataSourceType as EnergyUsageDataSourceType | null}
            setDataSourceType={setDataSourceType}
          />
        ) : (
          <EmaasEnergyUsageHOCSite
            requestContext={requestContext}
            bearerToken={bearerToken}
            emaasContext={emaasContext}
            dataSourceType={dataSourceType as EnergyUsageDataSourceType | null}
            setDataSourceType={setDataSourceType}
          />
        )}
      </DataContextProvider>
    );
  },
  shouldComponentNotUpdate
);

export default EmaasEnergyUsageWidgetSite;
